import { render, staticRenderFns } from "./IconFlagBadge.vue?vue&type=template&id=0451ea66&scoped=true&functional=true&"
import script from "./IconFlagBadge.vue?vue&type=script&lang=ts&"
export * from "./IconFlagBadge.vue?vue&type=script&lang=ts&"
import style0 from "./IconFlagBadge.vue?vue&type=style&index=0&id=0451ea66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "0451ea66",
  null
  
)

export default component.exports